import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

/* Accessible bilingual toggle. Renders a single button that swaps
 * to the OTHER language, so the current language is clearly implied
 * by the button label. Kept small — sits in the header alongside
 * the desktop nav on desktop, and inside the mobile drawer on mobile. */

export default function LanguageToggle({ onSwitch }) {
  const { lang, setLang, t } = useLanguage();
  const nextLang = lang === 'en' ? 'cy' : 'en';
  const nextLabel = t(nextLang === 'cy' ? 'lang.switch.to.cy' : 'lang.switch.to.en');
  const otherHtmlLang = nextLang === 'cy' ? 'cy' : 'en-GB';

  const handleClick = () => {
    setLang(nextLang);
    if (typeof onSwitch === 'function') onSwitch(nextLang);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="language-toggle"
      aria-label={t('btn.language.aria')}
      className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full font-bold tf-focus"
      style={{
        background: '#fff',
        color: 'var(--tf-purple)',
        border: '1px solid var(--tf-purple-light)',
        fontSize: 12,
        cursor: 'pointer',
        minHeight: 40,
      }}
    >
      <Languages size={14} aria-hidden="true" focusable="false" />
      <span lang={otherHtmlLang}>{nextLabel}</span>
    </button>
  );
}
